import { gql } from '@apollo/client'

const UNBLOCK_BRAND_CURATION_TASK_SUBSCRIPTION = gql`
  subscription onUnblockBrandCurationTask {
    unblockBrandCurationTask {
      brandCurationTaskId
      awaitingStatus
      reason
    }
  }
`

export default UNBLOCK_BRAND_CURATION_TASK_SUBSCRIPTION
